import {
  AppBar,
  Box,
  Button,
  Container,
  Stack,
  Toolbar,
  styled,
} from "@mui/material";
import "App.css";
import { Logo } from "components";
import { HEADER_DESKTOP_HEIGHT, HEADER_MOBILE_HEIGHT } from "config";
import { useLocation, useNavigate } from "react-router-dom";
import cssStyles from "utils/cssStyles";
import FooterSimple from "./FooterSimple";

export const ToolbarStyle = styled(Toolbar, {
  shouldForwardProp: (prop) => prop !== "transparent" && prop !== "scrolling",
})(({ transparent, scrolling, theme }) => ({
  height: HEADER_MOBILE_HEIGHT,
  ".nav-btn": {
    color: theme.palette.grey[100],
    "&.active": { color: theme.palette.primary.main },
  },
  backgroundColor: theme.palette.background.default,
  transition: theme.transitions.create(["height", "background-color"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.short,
  }),
  [theme.breakpoints.up("md")]: {
    height: HEADER_DESKTOP_HEIGHT,
  },
  ...(transparent && {
    ".nav-btn": {
      color: theme.palette.common.white,
      "&.active": { color: theme.palette.primary.main },
    },
    backgroundColor: "transparent",
  }),
  ...(scrolling && {
    ...cssStyles(theme).bgBlur(),
    ".nav-btn": {
      color: theme.palette.grey[100],
      "&.active": { color: theme.palette.primary.main },
    },
    [theme.breakpoints.up("md")]: {
      height: HEADER_DESKTOP_HEIGHT - 20,
    },
  }),
}));
const isPC =
  navigator.userAgent.toLowerCase().indexOf("windows") !== -1 ||
  navigator.userAgent.toLowerCase().indexOf("macintosh") !== -1;

if (!isPC && window.location.host.startsWith("intro.")) {
  // Redirect the user to a specific URL
  const { protocol, host, pathname } = window.location;
  window.location.href = `${protocol}//${host
    .split(".")
    .slice(1)
    .join(".")}${pathname}`;
}

export default function LayoutDefault({ isScrolling, children }) {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const transparent = ["/"].includes(pathname);

  return (
    <Box sx={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      <AppBar
        sx={{
          boxShadow: 0,
          bgcolor: "transparent",
        }}
      >
        <ToolbarStyle
          disableGutters
          transparent={transparent}
          scrolling={isScrolling}
        >
          <Container
            sx={{
              display: "flex",
              alignItems: "center",
              // borderBottom: transparent && !black ? null : "1px solid",
              borderColor: true ? "white" : "grey.500",
              height: "100%",
              px: "0 !important",
            }}
          >
            <Logo white={transparent} />

            <Stack direction="row" sx={{ ml: 5 }}>
              {[
                { label: "About Us", value: "about" },
                { label: "Our Service", value: "service" },
                // { label: "PortFolio", value: "portfolio" },
                { label: "Contact Us", value: "contact" },
              ].map((item, i) => (
                <Button
                  key={i}
                  className={`nav-btn ${
                    pathname.split("/").includes(item.value) ? "active" : ""
                  }`}
                  sx={{
                    fontFamily: "Futura",
                    fontWeight: 500,
                    fontSize: 16,
                    borderRadius: 0,
                    p: "0 20px",
                    lineHeight: "1 !important",
                    ":not(:last-child)": {
                      borderRight: "1px solid",
                      borderColor: "grey.300",
                    },
                  }}
                  onClick={() => {
                    navigate(`/${item.value}`);
                  }}
                >
                  {item.label}
                </Button>
              ))}
            </Stack>
          </Container>
        </ToolbarStyle>
      </AppBar>
      <Box sx={{ flexGrow: 1 }}>{children}</Box>
      <FooterSimple />
    </Box>
  );
}
